<template>
  <v-container>
    <v-toolbar flat class="mx-3">
      <v-toolbar-title>
        <router-link to="/">Yared Weldegebrial</router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-toolbar-items class="hidden-xs-only">
        <div id="nav">
          <v-btn text>
            <router-link to="/">Home</router-link>
          </v-btn>
          <v-btn text>
            <router-link to="/about">About</router-link>
          </v-btn>
          <v-btn text>
            <router-link to="/contact">Contact</router-link>
          </v-btn>

          <v-btn color="#1216e0" class=" mr-0 ml-5 white--text" small>
            <a
              :href="pdfLink"
              download="Yared_Weldegebrial_CV"
              target="_blank"
              class="white--text"
              title="Yared_Weldegebrial_CV"
              >Download CV</a
            >
          </v-btn>
        </div>
      </v-toolbar-items>

      <div class="hidden-sm-and-up">
        <v-menu offsets-y>
          <template v-slot:activator="{ on }">
            <v-app-bar-nav-icon v-on="on"></v-app-bar-nav-icon>
          </template>
          <v-list class="responsiveMenu">
            <v-list-item>
              <v-list-item-title>
                <router-link to="/" exact>Home</router-link>
              </v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>
                <router-link to="/about">About</router-link>
              </v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>
                <router-link to="/contact">Contact</router-link>
              </v-list-item-title>
            </v-list-item>

            <v-list-item>
              <a
                :href="pdfLink"
                download="Yared_Weldegebrial_CV"
                target="_blank"
                >Download CV</a
              >
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-toolbar>
  </v-container>
</template>

<script>
export default {
  name: "Header",
  // data: () => ({}),
  data() {
    return {
      pdfLink: require("../../assets/yared.pdf"),
    };
  },
};
</script>

<style scoped lang="scss">
#nav {
  padding: 10px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #1216e0;
    }
  }
}
</style>
